var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-dialog',{ref:"dialog",attrs:{"title":"Create Device Type Mapping Router","createLabel":"Create","destinations":_vm.destinations},on:{"payload":_vm.onPayload}})}
var staticRenderFns = []

export { render, staticRenderFns }